// University of Utah's undergraduate majors (#2748). Read on 2026-10-01
// from the official 2026-2027 Catalog at catalog.utah.edu (Programs). The
// catalog is a Coursedog site that loads its program list in the browser;
// the list was read from the same program records the page loads (Coursedog's
// program search for catalog "2026-2027 Catalog", school utah_peoplesoft),
// keeping every program of type "Undergraduate Major" with status Active.
// Seventeen inactive majors in the same records (Chinese, French, the
// Theatre BA and others) are left out, as are minors,
// certificates and graduate programs. Degrees are the catalog's own words
// (for example "Bachelor of Arts/Bachelor of Science").
// The catalog gives each program's college as a short code ("J & M Price
// College of Eng.", "S. F. E. School of Medicine", "Coll of Soc & Behavioral
// Sci"); the group names spell those out. Two display names carry their
// degree ("Medical Humanities BA/BS", "Bioinformatics BS"); the suffix is
// dropped here because the degree column shows it. World Languages and
// Cultures lists its emphases in the catalog name; they are kept as a note.
// The Bachelor of Interdisciplinary Studies belongs to no college in the
// catalog ("University of Utah"), so it stands as university-wide. The KB's
// majors list was not needed.
const majors = {
    "slug": "university-of-utah",
    "read": "2026-10-01",
    "intro": "Every active bachelor's degree major in the University of Utah's official 2026-2027 Catalog, grouped by the college that offers it, with the degree it leads to. Degrees are written as the catalog writes them. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Architecture + Planning",
            "source": {
                "label": "University of Utah 2026-2027 Catalog, Programs",
                "url": "https://catalog.utah.edu/programs"
            },
            "majors": [
                {
                    "name": "Architectural Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Architectural Studies",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Design",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Games",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Urban Ecology",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "University of Utah 2026-2027 Catalog, Programs",
                "url": "https://catalog.utah.edu/programs"
            },
            "majors": [
                {
                    "name": "Educational Psychology",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Elementary Education",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Special Education",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Fine Arts",
            "source": {
                "label": "University of Utah 2026-2027 Catalog, Programs",
                "url": "https://catalog.utah.edu/programs"
            },
            "majors": [
                {
                    "name": "Art History",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Art Teaching",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Ballet",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Contemporary Dance",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Dance Teaching",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Film & Media Arts",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Graphic Design",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Music",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Music",
                    "degree": "Bachelor of Music"
                },
                {
                    "name": "Music Education",
                    "degree": "Bachelor of Music Education"
                },
                {
                    "name": "Studio Art",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Theatre",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Theatre",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Theatre Teaching",
                    "degree": "Bachelor of Fine Arts"
                }
            ]
        },
        {
            "name": "College of Health",
            "source": {
                "label": "University of Utah 2026-2027 Catalog, Programs",
                "url": "https://catalog.utah.edu/programs"
            },
            "majors": [
                {
                    "name": "Community Health Promotion and Education",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Emergency Medical Services",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Health and Physical Education Teaching",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Kinesiology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Parks, Recreation and Tourism",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Recreational Therapy",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Speech and Hearing Science",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Humanities",
            "source": {
                "label": "University of Utah 2026-2027 Catalog, Programs",
                "url": "https://catalog.utah.edu/programs"
            },
            "majors": [
                {
                    "name": "Communication",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Diplomacy",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "English",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "English Education",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "English Education",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Ethnic Studies",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Gender Studies",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "History",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "History Teaching",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "International and Area Studies",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Linguistics",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Medical Humanities",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Philosophy",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "World Languages and Cultures",
                    "degree": "Bachelor of Arts",
                    "note": "Emphases: Arabic, Chinese, Classical Civilization, Comparative Literature, Cultural Studies, French, German, Greek, Italian, Japanese, Korean, Latin, Persian, Portuguese, Religious Studies, Russian, Spanish."
                },
                {
                    "name": "Writing and Rhetoric Studies",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "University of Utah 2026-2027 Catalog, Programs",
                "url": "https://catalog.utah.edu/programs"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Science",
            "source": {
                "label": "University of Utah 2026-2027 Catalog, Programs",
                "url": "https://catalog.utah.edu/programs"
            },
            "majors": [
                {
                    "name": "Applied Mathematics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Atmospheric Sciences",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biochemistry",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Bioinformatics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biology",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Biology Teaching",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Chemistry",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Earth & Environmental Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Earth Science Composite Teaching",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Geological Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Geoscience",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Mathematics",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Mathematics Teaching",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Metallurgical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Mining Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Physics",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Physics Teaching",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                }
            ]
        },
        {
            "name": "College of Social Work",
            "source": {
                "label": "University of Utah 2026-2027 Catalog, Programs",
                "url": "https://catalog.utah.edu/programs"
            },
            "majors": [
                {
                    "name": "Health & Human Services",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Social Work",
                    "degree": "Bachelor of Social Work"
                }
            ]
        },
        {
            "name": "College of Social and Behavioral Science",
            "source": {
                "label": "University of Utah 2026-2027 Catalog, Programs",
                "url": "https://catalog.utah.edu/programs"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Criminology",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Economics",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Environmental & Sustainability Studies",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Financial Planning and Counseling",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Geographic Information Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Geography",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Health, Society, and Policy",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Human Development and Family Studies",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Neuroscience",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Political Science",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Psychology",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Sociology",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                }
            ]
        },
        {
            "name": "David Eccles School of Business",
            "source": {
                "label": "University of Utah 2026-2027 Catalog, Programs",
                "url": "https://catalog.utah.edu/programs"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Business Administration",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Finance",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Information Systems",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Management",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Marketing",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                },
                {
                    "name": "Operations and Supply Chain",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Quantitative Analysis of Markets and Organizations",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "John and Marcia Price College of Engineering",
            "source": {
                "label": "University of Utah 2026-2027 Catalog, Programs",
                "url": "https://catalog.utah.edu/programs"
            },
            "majors": [
                {
                    "name": "Artificial Intelligence",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Computer Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Construction Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Data Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Software Development",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "S.J. Quinney College of Law",
            "source": {
                "label": "University of Utah 2026-2027 Catalog, Programs",
                "url": "https://catalog.utah.edu/programs"
            },
            "majors": [
                {
                    "name": "Legal Studies",
                    "degree": "Bachelor of Arts/Bachelor of Science"
                }
            ]
        },
        {
            "name": "Spencer Fox Eccles School of Medicine",
            "source": {
                "label": "University of Utah 2026-2027 Catalog, Programs",
                "url": "https://catalog.utah.edu/programs"
            },
            "majors": [
                {
                    "name": "Medical Laboratory Science",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "University-wide",
            "source": {
                "label": "University of Utah 2026-2027 Catalog, Programs",
                "url": "https://catalog.utah.edu/programs"
            },
            "majors": [
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "Bachelor of Interdisciplinary Studies"
                }
            ]
        }
    ]
};

export default majors;
